module.exports = __webpack_public_path__ + "static/tnd-e68f0aa1e17525f357884ab4764d62fa.png";